<template>
  <div>
    <el-row>
      <el-col :span="12">
        <ul>
          <li>供应商客户名称：{{ titleData.GYS_NAME }}</li>
          <li>送货日期：{{ titleData.SEND_DAY }}</li>
        </ul>
      </el-col>
      <el-col :span="12">
        <ul>
          <li>退货时间：{{ titleData.APPLICATION_TIME }}</li>
          <li>退货总金额：{{ totalFee }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" stripe border>
        <el-table-column label="序号" type="index" width="50px"></el-table-column>
        <el-table-column label="产品编码" prop="PRODUCT_CODE" min-width="100px"></el-table-column>
        <el-table-column label="产品名称" prop="PRODUCT_NAME"></el-table-column>
        <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
        <el-table-column label="一级大类名称" prop="FIRST_CATEGORY_NAME" min-width="100px"></el-table-column>
        <el-table-column label="退货数量" prop="RETURN_COUNT"></el-table-column>
        <el-table-column label="退货总金额" prop="RETURN_WORTH"></el-table-column>
        <el-table-column label="退货原因" prop="RETURN_REASON"></el-table-column>
      </el-table>
    </el-row>
    <el-row style="margin-top: 20px; float: right" v-if="titleData.STATUS == 1">
      <el-button size="medium" @click="auditReturn(0)">拒绝</el-button>
      <el-button size="medium" type="primary" @click="auditReturn(1)">通过</el-button>
    </el-row>
  </div>
</template>
<script>
import { auditGYSReturnFun, getGYSCusReturnAuditDetailFun } from 'api/returnCheck';

export default {
  data() {
    return {
      titleData: JSON.parse(sessionStorage.getItem('returnAuditSupplierCusDetailTitleData')),
      tableData: [],
    };
  },
  computed: {
    totalFee() {
      return this.tableData.reduce((total, item) => total += Number(item.RETURN_WORTH), 0).toFixed(2);
    },
  },
  methods: {
    // 进入拉取数据
    queryDetail() {
      const params = {
        GYS_ID: this.$route.params.gid,
        APPROVAL_ID: this.$route.params.aid,
      };
      getGYSCusReturnAuditDetailFun(params).then((res) => {
        if (res.length) {
          this.tableData = [...res];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    auditReturn(AGREE) {
      this.$confirm(`您确定${AGREE ? '通过' : '拒绝'}该条退货申请吗?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          const params = {
            GYS_ID: this.$route.params.gid,
            APPROVAL_ID: this.$route.params.aid,
            AGREE,
          };
          auditGYSReturnFun(params).then((res) => {
            this.$message.show({ text: '审核已提交', type: 'success' });
            this.$router.go(-1);
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        }).catch(() => {
          this.$message.show({ type: 'info', text: '取消操作' });
        });
    },
  },
  created() {
    this.queryDetail();
  },
};
</script>
<style>
ul {
  list-style: none;
  min-height: 5px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/audit/returnAuditSupplierCusDetail.vue